var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllCampaignsBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.499 7.5H1.49902V9H10.499V7.5ZM10.499 4.5H1.49902V6H10.499V4.5ZM1.49902 12H7.49902V10.5H1.49902V12ZM16.124 8.625L17.249 9.75L12.0065 15L8.62402 11.625L9.74902 10.5L12.0065 12.75L16.124 8.625Z",
    fill: "#2D3036"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllCampaignsBlack);
export default __webpack_public_path__ + "static/media/all-campaigns-black.daf42e4d0ea62b9248185b76b4cf2f0c.svg";
export { ForwardRef as ReactComponent };